<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-codigo">
                <label class="label-caption">Agenda</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdagenda) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtagenda) }}</div>
            </div>

            <div class="form-item-char05">
                <label class="label-caption">Hora</label>
                <div class="field-label field-label-center">{{ Funcoes.formatTimeFromJson(objView.hragenda) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Assunto</label>
                <div class="field-label">{{ objView.assunto }}</div>
            </div>

            <button @click="closeForm">Retornar</button>
            <button class="btn-confirm" @click="abrirModal">Finalizar</button>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Anotações do Atendimento</label>
                <textarea v-model="edObservacoes" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row">
            <div class="form-item">
                <label class="label-caption">Solicitação</label>
                <input type="text" v-model="edSolicitacao" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Prazo</label>
                <input type="date" v-model="edDataPrazo" />
            </div>

            <div class="form-item-char40"><GabineteDepartamentoSelect v-model:departamentoSelecionado="idDepartamento"/></div>

            <button type="button" class="buttom-icon--add" @click="incluiRequisicao" />
        </div>
    </div>
    

    <div v-if="lsPessoas.length>0" class="form-edit-page row-space">
        <table>
            <thead><tr>
                <th class="col-width-char15">CPF</th>
                <th>Nome</th>
                <th class="col-width-fone">Celular</th>
                <th class="col-width-char40">Empresa</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsPessoas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char15 center">{{ obj.cpf }}</td>
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-fone center">{{ obj.celular }}</td>
                    <td class="col-width-char40">{{ obj.empresa_nome }}</td>
                </tr>
            </tbody>
        </table>
    </div>


    
    <div v-if="lsRequisicoes.length>0" class="table-wrapper row-space">
        <table>
            <thead><tr>
                <th>SOLICITAÇÕES DESTE ATENDIMENTO</th>
                <th>Prazo</th>
                <th>Departamento</th>
                <th></th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsRequisicoes" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td>{{ obj.solicitacao }}</td>
                    <td class="col-width-fone center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char40">{{ obj.nmdepartamento }}</td>
                    <td class="col-width-char05"><div class="row-center">
                        <button class="btn-icon btn-icon--trash" @click="abrirModalExclusao(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>



    <div v-if="lsRequisicoesAnteriores.length>0">
        <br>
        <div class="table-wrapper"><table>
            <thead><tr>
                <th>SOLICITAÇÕES ANTERIORES</th>
                <th>Data</th>
                <th>Prazo</th>
                <th>Departamento</th>
                <th>Atendimento</th>
                <th>Situação</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsRequisicoesAnteriores" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td>{{ obj.solicitacao }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtsolicitacao) }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtprazo) }}</td>
                    <td class="col-width-char40">{{ obj.nmdepartamento }}</td>
                    <td class="col-width-char15 center">{{ obj.dhatendimento }}</td>
                    <td class="col-width-char15">{{ obj.nmstatus }}</td>
                </tr>
            </tbody>
        </table></div>
    </div>


    <ConfirmModal ref="confirmModal" />
    <ConfirmModal ref="confirmModalExcluir" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericDelete, genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import GabineteDepartamentoSelect from '@/selects/GabineteDepartamentoSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const confirmModal = ref(null)
const confirmModalExcluir = ref(null)
const emit=defineEmits(['close', 'salvo'])
const props=defineProps({idEdicao: {type: Number, default: 0}})

const edDataPrazo = ref(null);
const edObservacoes = ref(null);
const edSolicitacao = ref(null);
const msgAlerta = ref(false);
const idDepartamento = ref(null);
const isLoading = ref(false);
const lsPessoas = ref([]);
const lsRequisicoes = ref([]);
const lsRequisicoesAnteriores = ref([]);
const objView = ref({});


async function abrirModal() {
    const confirmado = await confirmModal.value.show({
        message: 'Deseja fazer o fechamento do atendimento?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        encerrarAtendimento();    
    } else {
        emit('close');
    }
}


async function abrirModalExclusao(obj){
    const confirmado = await confirmModalExcluir.value.show({
        message: "Confirma exclusão da solicitação?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){excluiSolicitacao(obj)}
}


function closeForm(){
    emit('close');
}

async function encerrarAtendimento(){
    try{
        msgAlerta.value=null;
        const x = await genericPost('/gabinete/agenda/atendimento/finalizar', {
            idmunicipio: globalStore.idmunicipio,
            id: objView.value.id,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (x.bolok==1) {emit('close')} else {msgAlerta.value = x.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`}
}

async function excluiSolicitacao(obj){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        await genericDelete('gabinete_agenda_req', obj.id, globalStore.idusuario);
        await lerRequisicoes();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}

async function incluiRequisicao(){
    try {
        if (!edSolicitacao.value){throw new Error('Informe a solicitação')}
        Funcoes.validarData(edDataPrazo.value);
        if (!idDepartamento.value){throw new Error('Informe o departamento')}
        isLoading.value=true;
        msgAlerta.value=null;
        const r = await genericPut('/cad/gabinete_agenda_req', {
            idagenda: objView.value.id,
            idpessoa: objView.value.idgabinete_pessoa, //to-do: permitir selecionar quando usar lista
            iddepartamento: idDepartamento.value,
            dtsolicitacao: Funcoes.strDataAtual(),
            dtprazo: edDataPrazo.value,
            solicitacao: edSolicitacao.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok===1){
            await lerRequisicoes();
            edSolicitacao.value=null;
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;

        // ACESSO OBJETO E ANALISA SITUAÇÃO
        const req = await genericPost('/listas/gabinete_agenda', {idmunicipio: globalStore.idmunicipio, id: props.idEdicao});
        Object.assign(objView.value, req[0]);
        if (objView.value){
            // VALIDAÇÃO DO STATUS
            if (!objView.value.atendimento_dhinicio){
                const x = await genericPost('/gabinete/agenda/atendimento/iniciar', {
                    idmunicipio: globalStore.idmunicipio,
                    id: objView.value.id,
                    idlogin: globalStore.idlogin,
                    idusuario: globalStore.idusuario});
                if (x.bolok!=1) msgAlerta.value = x.erro;
            }
            lsPessoas.value = await genericPost('/listas/gabinete_pessoas', {
                idmunicipio: globalStore.idmunicipio,
                intparam1: objView.value.id});

            await lerRequisicoes();
            await lerRequisicoesAnteriores();
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const lerRequisicoes = async() => {
    try{
        msgAlerta.value=null;
        const req = await genericPost('/listas/gabinete_agenda_req', {
            idmunicipio: globalStore.idmunicipio, 
            intparam1: objView.value.id});
        lsRequisicoes.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`}
}

async function lerRequisicoesAnteriores() {
    try{
        msgAlerta.value=null;
        const req = await genericPost('/listas/gabinete_agenda_req', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: objView.value.idgabinete_pessoa,
            intparam3: objView.value.id});  // EXCLUSÃO DA AGENDA ATUAL
        lsRequisicoesAnteriores.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`}
}

onMounted(lerDados)
</script>
